import * as React from 'react';

import {appHistory} from '../../../../../history';

import {DripSequencePreview} from '../drip-sequence-preview/drip-sequence-preview';
import {getDripEditionStatusInfo} from '../edition/get-edition-status-info';
import type {DripSequenceStatus} from '../edition/get-edition-status-info';
// @ts-expect-error - imported from .js/.jsx file
import {ArchiveIcon} from '../icon/svg/archive-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CloneIcon} from '../icon/svg/clone-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from '../icon/svg/eye-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from '../icon/svg/trash-icon';
import {ListRowWideWithHeader} from '../list-row/list-row-wide-with-header';

import {getDateForDripSequenceHeader} from './get-date-for-drip-sequence-header';

type DripSequence = {
    id: string;
    name: string;
    htmlUrlPath: string;
    editions: {
        totalCount: number;
    };
    status: DripSequenceStatus;
    startTrigger?: {
        humanReadableTitle: string;
        humanReadableSubtitle: string;
        id: string;
    };
    lastStatusChangeTime: number | null | undefined;
    totalRecipientCount: number;
    createdTime: number;
    deletedTime?: number | null | undefined;
    isRemovable: boolean;
};

export type DripEdition = {
    id: string;
    name: string;
    secondaryInfo: string | React.ReactNode;
    htmlUrlPath?: string;
    backgroundColor: string;
};

type Props = {
    dripSequence: DripSequence;
    editions?: DripEdition[];
    isLoading: boolean;
    isArchived: boolean;
    onDeleteDripSequence: (arg1: string) => any;
    onDuplicateDripSequence?: (arg1: string) => any;
    onRestoreDripSequence: (arg1: string) => any;
};

export function DripSequenceListItem(props: Props) {
    const {onDuplicateDripSequence} = props;

    const options = [
        {
            label: 'View',
            variant: 'secondary',
            icon: <EyeIcon wrapWithDiv={false} size={18} />,
            handleSelect: () => appHistory.push(props.dripSequence.htmlUrlPath),
        },
    ];

    if (onDuplicateDripSequence && !props.isArchived) {
        options.push({
            label: 'Make a copy',
            variant: 'secondary',
            icon: <CloneIcon size={16} />,
            handleSelect: () => {
                onDuplicateDripSequence(props.dripSequence.id);
            },
        });
    }

    if (props.isArchived) {
        options.push({
            label: 'Restore',
            variant: 'secondary',
            icon: <ArchiveIcon size={16} />,
            handleSelect: () => {
                props.onRestoreDripSequence(props.dripSequence.id);
            },
        });
    }

    if (props.dripSequence.isRemovable) {
        options.push({
            label: 'Archive',
            variant: 'destructive',
            icon: <TrashIcon size={16} />,
            handleSelect: () => {
                props.onDeleteDripSequence(props.dripSequence.id);
            },
        });
    }

    return (
        <ListRowWideWithHeader
            isArchived={props.isArchived}
            name={props.dripSequence.name}
            to={props.dripSequence.htmlUrlPath}
            metadataPrimary={getDateForDripSequenceHeader(props.dripSequence)}
            metadataSecondary={`${props.dripSequence.totalRecipientCount.toLocaleString()} ${
                props.dripSequence.totalRecipientCount === 1 ? 'recipient' : 'recipients'
            }`}
            status={getDripEditionStatusInfo(props.dripSequence.status) || undefined}
            secondaryLink={{
                text: 'See performance',
                onClick: () => appHistory.push(`${props.dripSequence.htmlUrlPath}/engagement`),
            }}
            // @ts-expect-error
            options={options}
        >
            <DripSequencePreview
                dripSequence={{
                    htmlUrlPath: props.dripSequence.htmlUrlPath,
                    startTrigger: props.dripSequence.startTrigger,
                    status: props.dripSequence.status,
                }}
                dripEditions={props.editions}
                isLoading={props.isLoading}
            />
        </ListRowWideWithHeader>
    );
}
